import React, { useState } from 'react';

// material-ui
import {
  Box,
  Grid,
  Button,
  MenuItem,
  Paper,
  Stack,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  AppBar,
  Toolbar,
  Slide,
  Divider,
  Card,
  CardContent
} from '@mui/material';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// icons
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import LinkIcon from '@mui/icons-material/Link';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

// assets
import Autodesk from 'assets/images/auth/autodesk.webp';
import GoogleDrive from 'assets/images/auth/googledrive_result.webp';
import Redas from 'assets/images/auth/redas_result.webp';
import SGBuildex from 'assets/images/auth/sgbuildex_result.webp';
import Excel from 'assets/images/auth/excel.png';

// store
import useExtractStore from '../../store/useExtract';
import ListProjectPage from './project';
import { useDeleteTransform, useTransformDetail, useTransformList } from '../../hooks/useTransformation';
import ConfirmDeleteDialog from '../../components/alert/alertDialog';
import SnackbarAlert from '../../components/alert/alertSnackbar';

// ==============================|| TRANSITION ||============================== //
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// ==============================|| DATA ||============================== //
const rows = [
  { id: 1, type: 'Issue', data: 'User data flow 1' },
  { id: 2, type: 'Form', data: 'User data flow 2' },
  { id: 3, type: 'Submittal', data: 'User data flow 3' }
];

const currencies = [
  { value: 'all', label: 'All' },
  { value: 'issue', label: 'Issue' },
  { value: 'form', label: 'Form' },
  { value: 'rfi', label: 'RFI' },
  { value: 'submittal', label: 'Submittal' },
  { value: 'file', label: 'File' }
];

const connectors = [
  { img: Excel, title: 'Integrasia Utama' },
  { img: Autodesk, title: 'Bimage' },
  { img: SGBuildex, title: 'SgBuildex111' },
  { img: Redas, title: 'Redaspiuser' }
];

// ==============================|| MAIN ||============================== //
export default function LoadDataPage() {
  const { hubname, openProject, setCloseProject, setHubName } = useExtractStore();
  const { data: dataTransform, isFetching, isError } = useTransformList();

  const [dataTransformDetail, setdataTransformDetail] = useState(null);
  const [selectedId, setselectedId] = useState(0)
  const { mutate: deleteTransform, isPending: isDeleteTransform } = useDeleteTransform();
  const [openDetail, setopenDetail] = useState(false);
  const handleClickDetail = (param) => {
    setopenDetail(true);
    setdataTransformDetail(param);
  };
  const handleCloseModalDetail = () => setopenDetail(false);

  const [openConnector, setOpenConnector] = useState(false);
  const [openModal, setopenModal] = useState(false);
  const [alertDialog, setalertDialog] = useState(false)

  const [snackbar, setSnackbar] = useState({
    open: false,
    title: '',
    content: '',
    type: 'error'
  });

  const handleCloseSnackbar = () => {
    setSnackbar({
      open: false,
      title: '',
      content: '',
      type: 'error'
    });
  };

  const handleCloseModal = () => setopenModal(false);
  const handleConfirmAddTransform = () => {
    const message = {
      open: true,
      title: `Add Transformation success`,
      content: `You Successfully Add Tranforation Data`,
      type: 'success'
    };
    setTimeout(() => {
      setSnackbar(message);
    }, 500);
    setopenModal(false);
  }

  const handleCreateNewTransform = () => {
    setopenModal(true);
  };

  const handleDeleteTransformation= (data) => {
    setselectedId(data.id);
    setalertDialog(true);
  };

  const handleConfirmDelete = () => {
    deleteTransform(selectedId, {
      onSuccess: () => {
        const message = {
          open: true,
          title: `Delete Transformation success`,
          content: `You Successfully delete Tranforation Data`,
          type: 'success'
        };
        setalertDialog(false);
        setselectedId(null);
        setTimeout(() => {
          setSnackbar(message);
        }, 500);
      }
    });
  };

  return (
    <>
      {snackbar.open && <SnackbarAlert open={snackbar.open} handleClose={handleCloseSnackbar} message={snackbar} />}
      <Box>
        {/* FILTER */}
        <Stack py={2} direction={'row'} justifyContent={'flex-end'} spacing={2} flex={1}>
          {/* <TextField
            sx={{
              width: '20%'
            }}
            id="outlined-select-currency"
            select
            label="Select Type"
            defaultValue="all"
            // helperText="Please select your currency"
          >
            {currencies.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField> */}
          <Button sx={{ fontWeight: 'bold', fontSize: 13 }} onClick={handleCreateNewTransform} variant="contained" startIcon={<AddIcon />}>
            CREATE NEW DATA FLOW
          </Button>
        </Stack>

        {/* TABLE */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: '#fff'
          }}
        >
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    bgcolor: 'grey.50',
                    '& th': {
                      fontWeight: 'bold',
                      borderBottom: '2px solid',
                      borderColor: 'divider'
                    }
                  }}
                >
                  <TableCell width="65%">Data</TableCell>
                  <TableCell width="20%" align="center">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {dataTransform?.map((row) => (
                  <TableRow key={row.id} hover>
                    <TableCell>
                      <Typography variant="subtitle2">{row.flow_name}</Typography>
                    </TableCell>

                    <TableCell align="center">
                      <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center' }}>
                        <Tooltip title="View Data">
                          <IconButton
                            onClick={() => handleClickDetail(row)}
                            size="small"
                            sx={{
                              border: '1px solid',
                              borderColor: 'first.dark',
                              color: 'first.dark',
                              '&:hover': {
                                bgcolor: 'first.dark',
                                color: '#fff'
                              },
                              width: 32,
                              height: 32
                            }}
                          >
                            <VisibilityOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit Data">
                          <IconButton
                            size="small"
                            sx={{
                              border: '1px solid',
                              borderColor: 'success.dark',
                              color: 'success.dark',
                              '&:hover': {
                                bgcolor: 'success.dark',
                                color: '#fff'
                              },
                              width: 32,
                              height: 32
                            }}
                          >
                            <EditOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Data">
                          <IconButton
                          onClick={() => handleDeleteTransformation(row)}
                            size="small"
                            sx={{
                              border: '1px solid',
                              borderColor: 'error.dark',
                              color: 'error.dark',
                              '&:hover': {
                                bgcolor: 'error.dark',
                                color: '#fff'
                              },
                              width: 32,
                              height: 32
                            }}
                          >
                            <DeleteOutlineOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* LIST PROJECT FULLSCREEN */}
        <Dialog fullScreen open={openModal} onClose={handleCloseModal} TransitionComponent={Transition}>
          <AppBar sx={{ position: 'relative' }}>
            <Toolbar>
              {openProject && (
                <IconButton edge="start" color="inherit">
                  <ArrowBackIcon />
                </IconButton>
              )}
              <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h6">
                Create New Data Flow
              </Typography>
              <Button color="inherit" onClick={handleCloseModal}>
                CLOSE
              </Button>
            </Toolbar>
          </AppBar>
          <ListProjectPage onConfirm={handleConfirmAddTransform} />
        </Dialog>
      </Box>

      <Dialog maxWidth="sm" fullWidth open={openDetail} onClose={handleCloseModalDetail}>
        <DialogTitle mx={3} id="alert-dialog-title">
          {dataTransformDetail?.flow_name}
          <Stack direction="column" pt={2}>
           <Stack direction={"row"} alignItems={"center"} spacing={1}>
           <Typography variant="h6" color="text.secondary">
              Source: 
            </Typography>
            <Typography fontWeight="bold">{dataTransformDetail?.source_provider}</Typography>
           </Stack>
            

            {/* <ArrowForwardIcon fontSize="small" color="action" /> */}
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <Typography variant="h6" color="text.secondary">
              Destination:
            </Typography>
            <Typography fontWeight="bold">{dataTransformDetail?.destination_provider}</Typography>
            </Stack>
           
          </Stack>
        </DialogTitle>
        <DialogContent>
            <Box px={3} py={1}>
                <Grid container spacing={3}>
                  <Grid size={{ xs: 12, md: 12 }}>
                    <Box  sx={{ height: '47vh' }}>
                      <Box
                        sx={{
                          height: '100%',
                          overflowY: 'auto'
                        }}
                      >
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          py={1}
                          sx={{
                            borderBottom: '1px solid',
                            borderColor: 'divider'
                          }}
                        >
                          <Typography fontWeight="bold">{dataTransformDetail?.source_provider}</Typography>
                          <Typography fontWeight="bold">{dataTransformDetail?.destination_provider}</Typography>
                        </Box>

                        <Divider sx={{ mb: 1 }} />

                        {dataTransformDetail?.mappings.map((a) => {
                          return (
                            <Box
                              key={a.key}
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              py={1}
                              sx={{
                                borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                                '&:last-child': {
                                  borderBottom: 'none'
                                }
                              }}
                            >
                              <Typography sx={{ textAlign: 'left' }}>{a.from}</Typography>
                              <Typography sx={{ textAlign: 'right' }}>{a.to}</Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
            </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModalDetail}>CLOSE</Button>
        </DialogActions>
      </Dialog>

      <ConfirmDeleteDialog
          open={alertDialog}
          loading={isDeleteTransform}
          onCancel={() => setaLertDialog(false)}
          onConfirm={handleConfirmDelete}
          title={`Delete Transformation`}
          description={`Are you sure you want to delete this transformation`}
        />
    </>
  );
}
